import { render, staticRenderFns } from "./OrderSummaryRow.vue?vue&type=template&id=2e9126c2&scoped=true"
import script from "./OrderSummaryRow.vue?vue&type=script&lang=ts"
export * from "./OrderSummaryRow.vue?vue&type=script&lang=ts"
import style0 from "./OrderSummaryRow.vue?vue&type=style&index=0&id=2e9126c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9126c2",
  null
  
)

export default component.exports